import React, { useEffect, useState, useCallback } from "react";
import { DatePicker, Select, Popover, Input, Card, message } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import DealCard from "./addDeal/dealCard";
import Button from "../components/common/button";
import { fetchServiceCategory } from "../store/slices/serviceSlice";
import { useDispatch } from "react-redux";
import { updateService } from "../api/service";

const { Option } = Select;

const AppointmentSettingsCard = ({ data, setDate, setTime, showModal }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedHour, setSelectedHour] = useState("12");
  const [selectedFromHour, setSelectedFromHour] = useState("12");
  const [selectedMinute, setSelectedMinute] = useState("00");
  const [selectedFromMinute, setSelectedFromMinute] = useState("00");
  const [selectedAmPm, setSelectedAmPm] = useState("AM");
  const [selectedFromAmPm, setSelectedFromAmPm] = useState("AM");
  const [displayedTime, setDisplayedTime] = useState("");
  const [selectedToTime, setSelectedToTime] = useState("");
  const [selectedFromTime, setSelectedFromTime] = useState("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [appointmentEdit, setAppointmentEdit] = useState(false);
  const dispatch = useDispatch();
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleHourChange = (value) => {
    setSelectedHour(value);
  };
  const handleFromAmPmChange = (value) => {
    setSelectedFromAmPm(value);
  };
  const handleFromHourChange = (value) => {
    setSelectedFromHour(value);
  };
  const handleFromMinuteChange = (value) => {
    setSelectedFromMinute(value);
  };

  const handleMinuteChange = (value) => {
    setSelectedMinute(value);
  };

  const handleAmPmChange = (value) => {
    setSelectedAmPm(value);
  };

  const handleOkClick = () => {
    const formattedHour = selectedHour.padStart(2, "0");
    const formattedMinute = selectedMinute.padStart(2, "0");
    const formattedFromMinute = selectedFromMinute.padStart(2, "0");
    const formattedTime = `${formattedHour}:${formattedMinute} ${selectedAmPm}`;
    setDisplayedTime(formattedTime);
    const formattedToHourr =
      selectedAmPm === "PM"
        ? (parseInt(selectedHour) + 12).toString().padStart(2, "0")
        : selectedHour.padStart(2, "0");
    const formattedToTime = `${formattedToHourr}:${formattedMinute}:00`;
    const formattedFromAPIHour =
      selectedFromAmPm === "PM"
        ? (parseInt(selectedFromHour) + 12).toString().padStart(2, "0")
        : selectedFromHour.padStart(2, "0");
    const formattedFromTime = `${formattedFromAPIHour}:${formattedFromMinute}:00`;
    setSelectedFromTime(formattedFromTime);
    setSelectedToTime(formattedToTime);
    setPopoverOpen(false);
  };

  const timePickerContent = (
    <div className="flex flex-col h-24">
      <div className="flex justify-center items-center mb-1">from</div>
      <div className="grid grid-cols-3 gap-1 w-31 h-2.5">
        <Select
          defaultValue="12"
          onChange={handleFromHourChange}
          className="border-primaryBlue"
        >
          {[...Array(12).keys()].map((hour) => (
            <Option key={hour + 1}>{hour + 1}</Option>
          ))}
        </Select>
        <Select
          defaultValue="00"
          onChange={handleFromMinuteChange}
          className="border-primaryBlue h-1.4 w-2.4 "
        >
          {[...Array(60).keys()].map((minute) => (
            <Option key={minute}>{minute < 10 ? `0${minute}` : minute}</Option>
          ))}
        </Select>
        <Select
          defaultValue="AM"
          onChange={handleFromAmPmChange}
          className="border-primaryBlue h-5.4 w-2.4 "
        >
          <Option value="AM">AM</Option>
          <Option value="PM">PM</Option>
        </Select>
      </div>
      <div className="flex items-center justify-center mb-1 mt-4">to</div>
      <div className="grid grid-cols-3 gap-1 w-31 h-2.5">
        <Select
          defaultValue="12"
          onChange={handleHourChange}
          className="border-primaryBlue"
        >
          {[...Array(12).keys()].map((hour) => (
            <Option key={hour + 1}>{hour + 1}</Option>
          ))}
        </Select>
        <Select
          defaultValue="00"
          onChange={handleMinuteChange}
          className="border-primaryBlue h-1.4 w-2.4 "
        >
          {[...Array(60).keys()].map((minute) => (
            <Option key={minute}>{minute < 10 ? `0${minute}` : minute}</Option>
          ))}
        </Select>
        <Select
          defaultValue="AM"
          onChange={handleAmPmChange}
          className="border-primaryBlue h-5.4 w-2.4 "
        >
          <Option value="AM">AM</Option>
          <Option value="PM">PM</Option>
        </Select>
      </div>
      <Button
        type="primary"
        onClick={handleOkClick}
        className="w-30.5 h-5.4 mt-4 bg-primaryPurple"
        title={"Save"}
      />
    </div>
  );

  const getServiceCategories = useCallback(async () => {
    dispatch(fetchServiceCategory());
  }, [dispatch]);

  const isAppointmentEdit = () => {
    setAppointmentEdit(!appointmentEdit);
  };
  const updateServiceAppointment = async () => {
    const to = `${
      selectedDate?.toISOString().split("T")[0]
    }T${selectedToTime}.000+00:00`;
    const from = `${
      selectedDate?.toISOString().split("T")[0]
    }T${selectedFromTime}.000+00:00`;
    const serviceTime = {
      to: to,
      from: from,
    };
    const payload = {
      serviceTime: serviceTime,
    };
    const res = await updateService(data?._id, payload);
    if (res) {
      setAppointmentEdit(false);
      message.success("Service Appointment Updated!");
    }
  };
  useEffect(() => {
    getServiceCategories();
  }, [getServiceCategories]);
  return (
    <Card className=" mr-2 shadow-md">
      <div>
        <DealCard
          data={data}
          openModal={() => showModal(data?._id)}
          isAppointment={true}
          isAppointmentEdit={isAppointmentEdit}
        />
      </div>
      {appointmentEdit ? (
        <div className="grid mb-2 px-2 gap-3 md:grid-cols-2 md:px-2 md:mb-2  lg:grid-cols-3 xl:grid-cols-3">
          <div className="bg-blue border border-gray-200  rounded ">
            <p className="font-bold text-primaryPurple">Available Date</p>
            <DatePicker
              value={selectedDate}
              placeholder="Select Date"
              onChange={handleDateChange}
              format="MM-DD-YYYY"
              disabledDate={(current) => {
                const today = new Date();
                const currentDate = new Date(current);
                return currentDate < today;
              }}
              className="border border-primaryBlue h-5.4 w-full rounded-md text-lg pl-2 flex justify-between text-grey text-sm"
            />
          </div>
          <div className="bg-blue border border-gray-200  rounded lg:mx-3 xl:mx-3 xl:h-full">
            <p className="font-bold text-primaryPurple">Available Time</p>
            <Popover
              content={timePickerContent}
              trigger="click"
              placement="bottom"
              open={popoverOpen}
              onOpenChange={(newOpen) => setPopoverOpen(newOpen)}
            >
              <Input
                placeholder="Select Time"
                value={displayedTime}
                className="border-1.5 border-primaryBlue w-full h-5.4 rounded-md text-lg pl-2 flex justify-between text-grey text-sm"
                suffix={<ClockCircleOutlined style={{ color: "grey" }} />}
              />
            </Popover>
          </div>
          <div className="flex justify-center  w-full">
            <Button
              title="Save"
              onClick={updateServiceAppointment}
              className="w-full xl:w-19 bg-primaryPurple mt-5"
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </Card>
  );
};

export default AppointmentSettingsCard;
